import { Proyecto } from "@/store/ProyectosStore";
import { AxiosResponse, AxiosStatic } from "axios";

class ProyectoService {
  axios;
  baseUrl;

  constructor(axios: AxiosStatic, apiUrl: string) {
    this.axios = axios;
    this.baseUrl = `${apiUrl}`;
  }

  getAll() {
    return this.axios.get(`${this.baseUrl}AllProyecto`);
  }

  getById (id: number): Promise<AxiosResponse<Proyecto>> {
    return this.axios.get(`${this.baseUrl}Proyecto/?id=${id}`)
  }

  update (data: Proyecto): Promise<AxiosResponse<Proyecto>> {
    return this.axios.put(`${this.baseUrl}Proyecto/?id=${data.IdProyecto}`, JSON.stringify(data))
  }

  add(data: Proyecto): Promise<AxiosResponse<Proyecto>> {
    return this.axios.post(`${this.baseUrl}Proyecto`, JSON.stringify(data));
  }

  delete (id: number) {
    return this.axios.delete(`${this.baseUrl}Proyecto/?id=${id}&deleteRefs=1`)
  }
}

export default ProyectoService;
